import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Layout, Modal, Row, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import Header from '../../common/compornents/layout/header/Header';
import HeaderRow5 from '../../common/compornents/layout/header/HeaderRow5';
import CustomerSearchTable from '../../common/compornents/layout/table/CustomerSearchTable';
import { notificationError, notificationInfo } from '../../common/compornents/notification';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';
import TokuisakiServ from '../../services/TokuisakiServ';

const { Option } = Select;
const { Footer } = Layout;

interface IProps {
  tok_cd: string;
  tok_cd2: string;
  yobidashimotoKbn: string;
  val: string[];
  setVal: (val: string[]) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const CustomerSearch: React.FC<IProps> = (props: IProps) => {
  //sessionStorageから取得
  var cd1 = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD) ?? '';
  var cd2 = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2) ?? '';
  var ksKtnCd = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.KYOTEN_CD) ?? '';
  var compnyCd = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD) ?? '';
  var compnyNm = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '';
  var accId = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '';
  var accNm = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '';

  if (props.yobidashimotoKbn === '2') {
    cd1 = props.tok_cd;
    cd2 = props.tok_cd2;
  }

  const [form] = Form.useForm();
  const [ktnList, setKtnList] = useState<any[]>([]);
  const [tokList, setTokList] = useState<any[]>([]);
  const [rIdx, changeRowIndex] = useState(-1);
  const [dspFlg, setDspFlg] = useState('');

  //初期化処理
  useEffect(() => {
    const init = async () => {
      if (props.yobidashimotoKbn === '1') {
        TokuisakiServ.getKsKyotenData()
          .then((json) => {
            setKtnList(() => json.data);
            form.setFieldsValue({
              ktn_cd: ksKtnCd,
            });
          })
          .catch((error) => {
            notificationError(
              '得意先検索',
              generateMessage(Message.ERROR_MASSAGE.ERR999, 'KS拠点検索')
            );
          });
      } else {
        setDspFlg('none');
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //行選択
  useEffect(() => {
    if (rIdx >= 0) {
      var vals = [];
      vals.push(tokList[rIdx].cd1);
      vals.push(tokList[rIdx].cd2);
      vals.push(tokList[rIdx].rnm);
      props.setVal(vals);
      dataClear();
      changeRowIndex(-1);
      props.setVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  //検索ボタン押下
  function dataSearch() {
    let data = form.getFieldsValue();

    // 前画面からの条件
    var kbn = props.yobidashimotoKbn;
    var tok_cd = props.tok_cd;
    var tok_cd2 = props.tok_cd2;
    // 画面入力条件
    var nm1 = data.searchNm1 || '';
    var nm2 = data.searchNm2 || '';
    var nm3 = data.searchNm3 || '';
    var adr1 = data.searchAdr1 || '';
    var adr2 = data.searchAdr2 || '';
    var adr3 = data.searchAdr3 || '';
    var ktn = data.ktn_cd || '';

    // APIに渡すパラメーターを設定
    var params = {
      nm1: nm1,
      nm2: nm2,
      nm3: nm3,
      adr1: adr1,
      adr2: adr2,
      adr3: adr3,
      ktn: ktn,
      kbn: kbn,
      cd1: tok_cd,
      cd2: tok_cd2,
    };

    // APIを呼び出しDBから値を取得
    TokuisakiServ.getTokuisakiData(params)
      .then((json) => {
        if (json.data.length >= 1000) {
          notificationInfo('得意先検索', generateMessage(Message.INFO_MASSAGE.INF010));
        }
        setTokList(() => json.data);
      })
      .catch((error) => {
        notificationError(
          '得意先検索',
          generateMessage(Message.ERROR_MASSAGE.ERR999, '得意先検索')
        );
      });
  }

  //クリアボタン押下
  function dataClear() {
    form.resetFields();
    setTokList(() => []);
    form.setFieldsValue({
      ktn_cd: ksKtnCd,
    });
  }

  //閉じるボタン押下
  function winClose() {
    dataClear();
    props.setVisible(false);
  }

  return (
    <>
      <Modal closable={false} footer={null} visible={props.visible} width={1300} centered>
        <Header screenName={'得意先検索'} />
        <Form
          form={form}
          layout="horizontal"
          autoComplete="off"
          style={{ backgroundColor: '#e6f7ff' }}
        >
          {/* ヘッダ情報（得意先、カンパニー、お客先様 */}
          <HeaderRow5
            tokCd={[cd1, cd2]}
            compnyCd={compnyCd}
            compnyNm={compnyNm}
            accId={accId}
            accNm={accNm}
          />
          {/* 得意先名検索文字 */}
          <Row style={{ paddingTop: '1vh' }}>
            <Col offset={2} xl={3} md={4} sm={6} xs={5}>
              <Form.Item label="得意先名検索文字"></Form.Item>
            </Col>
            <Col xl={4} md={5} sm={4} xs={5}>
              <Form.Item name={'searchNm1'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col xl={4} md={5} sm={4} xs={5}>
              <Form.Item name={'searchNm2'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col xl={4} md={5} sm={4} xs={5}>
              <Form.Item name={'searchNm3'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
          </Row>
          {/* 住所検索文字 */}
          <Row>
            <Col offset={2} xl={3} md={4} sm={6} xs={5}>
              <Form.Item label="住所検索文字" name={'address'}></Form.Item>
            </Col>
            <Col xl={4} md={5} sm={4} xs={5}>
              <Form.Item name={'searchAdr1'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col xl={4} md={5} sm={4} xs={5}>
              <Form.Item name={'searchAdr2'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col xl={4} md={5} sm={4} xs={5}>
              <Form.Item name={'searchAdr3'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
          </Row>
          {/* KS拠点 */}
          <Row>
            <Col offset={2} xl={3} md={4} sm={6} xs={5}>
              <Form.Item label="KS拠点" name={'ksKyoten'} style={{ display: dspFlg }}></Form.Item>
            </Col>
            <Col xl={7} md={5} sm={4} xs={5}>
              <Form.Item name={'ktn_cd'} style={{ display: dspFlg }}>
                <Select allowClear notFoundContent=' '>
                  {ktnList.length > 0 &&
                    ktnList.map((item, i) => {
                      return (
                        <Option key={i} value={item.ktn_cd}>
                          {item.ktn_nm}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            {/* 検索ボタンとクリアボタン */}
            <Col xl={{ offset: 7 }} md={{ offset: 6 }} xs={{ offset: 2 }}>
              <Space size={'large'}>
                <Button type="primary" onClick={dataSearch}>
                  <SearchOutlined />
                  検索
                </Button>
                <Button type="primary" onClick={dataClear}>
                  クリア
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>

        {/* テーブル */}
        <Row style={{ backgroundColor: '#e6f7ff', paddingTop: '2vh' }}>
          <Col offset={1} xs={22}>
            <CustomerSearchTable
              dataCustomer={tokList}
              rowIndex={rIdx}
              changeRowIndex={changeRowIndex}
            />
          </Col>
        </Row>
        <Footer
          style={{
            backgroundColor: '#e6f7ff',
            height: '70px',
          }}
        >
          <Row justify="end">
            <Col>
              <Button type="primary" onClick={winClose}>
                閉じる
              </Button>
            </Col>
          </Row>
        </Footer>
      </Modal>
    </>
  );
};

export default CustomerSearch;
